import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminFinanceiro: Routes = [
  {
    path: 'portadores',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'PORTADOR',
      menuKey: 'PORTADOR',
      breadcrumb: {
        label: 'Portadores',
        icon: 'pi pi-fw pi-money-bill'
      },
      backend_path: '/portadores'
    },
    loadChildren: () =>
      import('@app/modules/portador/portador.module').then(
        m => m.PortadorModule
      )
  },
  {
    path: 'contas-receber',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_CONTAS_RECEBER',
      menuKey: 'FIN_CONTAS_RECEBER',
      breadcrumb: {
        label: 'Contas a receber',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import('@app/modules/contas-receber/contas-receber.module').then(
        m => m.ContasReceberModule
      )
  },
  {
    path: 'contas-pagar',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_CONTAS_PAGAR',
      menuKey: 'FIN_CONTAS_PAGAR',
      breadcrumb: {
        label: 'Contas a pagar',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import('@app/modules/contas-pagar/contas-pagar.module').then(
        m => m.ContasPagarModule
      )
  },
  {
    path: 'movimentacao_financeira',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'FIN_MOV_FINANCEIRA',
      menuKey: 'FIN_MOV_FINANCEIRA',
      breadcrumb: {
        label: 'Movimentação financeira',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import(
        '@app/modules/movimentacao_financeira/movimentacao_financeira.module'
      ).then(m => m.MovimentacaoFinanceiraModule)
  },

];
